<div *ngIf="isHomePage" class="row justify-content-center">
  <div class="col-lg-12">
    <div class="home-title text-center text-white">
      <h2>Truck Driving Jobs</h2>
      <h1 class="mb-4">Choose a Career with Purpose</h1>
    </div>
  </div>
  <div class="col-lg-12 text-center">
    <a href="https://career.crengland.com/application">
      <button class="submitBnt searchBtn btn btn-custom" name="send">Apply Now</button>
    </a>
  </div>
  <div class="col-lg-12">
    <div class="home-title text-center text-white">
      <h4>OR</h4>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-xl-3"></div>
  <div class="col-xl-4">
    <div class="position-relative">
      <span class="p-fluid">
        <p-autoComplete
          #autocomplete
          (completeMethod)="searchState($event)"
          [(ngModel)]="selectedValue"
          [placeholder]="'Enter State or Zip'"
          [styleClass]="errorMessage ? 'search-autocomplete error' : 'search-autocomplete'"
          [suggestions]="sugestedState"
        ></p-autoComplete>
      </span>
      <div class="exclamation">
        <i class="far fa-exclamation-circle" *ngIf="errorMessage"></i>
      </div>
      <div class="clear">
        <i class="far fa-times" (click)="onClear()" *ngIf="selectedValue"></i>
      </div>
      <div class="text-right validation" [ngClass]="errorMessage ? '' : 'hidden'">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div class="col-xl-2">
    <button
      class="submitFindJob searchBtn btn btn-custom btn-block"
      (click)="onSearch()"
      name="send"
    >
      Find Jobs
    </button>
  </div>
  <div class="col-xl-3"></div>
</div>
